import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const CabIdListing = React.lazy(() => import('./CabIdListing'));

export const CabIdConfigs = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/cab-id/list',
    element: <CabIdListing />,
  },
];
